<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Hy5knd/tc-custom/9780292767324.jpg?1705324015720" alt="This image is the cover for the book Flatlanders, American Music Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flatlanders, American Music Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Conservative West Texas spawns radical creativity and lifelong bonds of friendship in this story of an unlikely band” from the renowned music journalist (<i>Kirkus Reviews</i>).</b><br/>  <br/> A group of three friends who made music in a house in Lubbock, Texas, recorded an album that wasn’t released and went their separate ways into solo careers. That group became a legend and then—twenty years later—a band. The Flatlanders—Joe Ely, Jimmie Dale Gilmore, and Butch Hancock—are icons in American music, with songs blending country, folk, and rock that have influenced a long list of performers, including Robert Earl Keen, the Cowboy Junkies, Ryan Bingham, Terry Allen, John Hiatt, Hayes Carll, Lucinda Williams, Steve Earle, and Lyle Lovett.<br/>  <br/> In <i>The Flatlanders: Now It’s Now Again</i>, Austin author and music journalist John T. Davis traces the band’s musical journey. He explores why music was, and is, so important in Lubbock and how earlier West Texas musicians such as Buddy Holly and Roy Orbison, as well as a touring Elvis Presley, inspired the young Ely, Gilmore, and Hancock. Davis recounts their first year (1972–1973) as a band, during which they recorded the songs that, decades later, were released as the albums <i>More a Legend Than a Band</i> and <i>The Odessa Tapes</i>. He follows the three musicians through their solo careers and into their first decade as a (re)united band, in which they cowrote songs for the first time on the albums <i>Now Again</i> and <i>Hills and Valleys</i> and recovered their extraordinary original demo tape, lost for forty years. Many roads later, the Flatlanders are finally both a legend and a band. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John T. Davis
      </h2>
      
      <p class="authorDescription body article"> The author of Austin City Limits: 25 Years of American Music, JOHN T. DAVIS hhas written about the music, personalities, and culture of Texas and the Southwest for numerous publications, including the Austin American-Statesman, Austin Chronicle, Austin Monthly, Texas Monthly, Texas Highways, San Antonio magazine, Billboard, Newsday, and the website culturemap.com. He has been interviewed by VH-1, CMT, and NPR and has appeared in the documentary film Lubbock Lights. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?757c4fc8